import angular from 'angular';
import projectsComponent from './projects.component';

let projectsModule = angular.module('projects', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('projects', projectsComponent);

export default projectsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/projects/projects.js